import React from "react";
import styled from "styled-components";
import ExtensionInputGroup from "./ExtensionInputGroup";
import { ExtensionSmall } from "app/popleads/components/ui-kit/Text";
import { colors } from "app/popleads/components/ui-kit/colors";
import useDealCancellationReasons from "app/popleads/hooks/useDealCancellationReasons";
import { CANCELLATION_NOTE_MAX_LENGTH, getCancellationReasons, isCancellationNoteRequired } from "../utils/constants";

const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: left;
    width: 100%;
`;

const StyledCounter = styled(ExtensionSmall)`
    display: block;
    text-align: right;
    margin-top: 4px;
    color: ${colors.neutral[600]};
`;

// Reason + note asked whenever a deal is set to Cancelled. The note is only asked for the reasons the
// company config marks as `noteRequired`.
const ExtensionCancellationReasonFields = ({ dealCampaignType, cancellationReason, cancellationNote, onChange }) => {
    const reasonsConfig = useDealCancellationReasons();
    const reasonOptions = getCancellationReasons(reasonsConfig, dealCampaignType).map((item) => ({
        label: item,
        value: item,
    }));
    const note = cancellationNote || "";

    return (
        <StyledContainer>
            <ExtensionInputGroup
                label="Cancellation Reason"
                type="select"
                options={reasonOptions}
                value={cancellationReason ? { label: cancellationReason, value: cancellationReason } : ""}
                onChange={(selected) =>
                    onChange({
                        cancellationReason: selected?.value || "",
                        cancellationNote: isCancellationNoteRequired(reasonsConfig, selected?.value) ? note : "",
                    })
                }
                placeholder="Select Cancellation Reason"
                required={true}
                variant="l3rnTech"
            />
            {isCancellationNoteRequired(reasonsConfig, cancellationReason) && (
                <div>
                    <ExtensionInputGroup
                        label="Cancellation Note"
                        type="input"
                        inpType="text"
                        onChange={(value) => onChange({ cancellationReason, cancellationNote: value })}
                        value={note}
                        placeholder="Please enter a short note"
                        minLength={1}
                        maxLength={CANCELLATION_NOTE_MAX_LENGTH}
                        debounceTime={0}
                        required={true}
                        variant="l3rnTech"
                    />
                    <StyledCounter>
                        {note.length}/{CANCELLATION_NOTE_MAX_LENGTH}
                    </StyledCounter>
                </div>
            )}
        </StyledContainer>
    );
};

export default ExtensionCancellationReasonFields;
